import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { ContentBlock } from '../../pages/components/';
import BaseFormContainer from '../../common/components/form/BaseFormContainer';

import * as transactionActions from '../transaction.actions';
import TransactionsSearchForm from './TransactionsSearchForm';
import { Localize } from '../../../locale/localization';
import { getUser } from '../../user/user.actions';
import { formatDate } from '../../../utils/date-utils';
import { formatProductDisplayName, sortTableAndHead } from '../../../utils/content-utils';
import { partial } from '../../common/utils/partial';
import Dialog from '../../common/components/Dialog';
import Table from '../../common/components/Table';
import TableHeader from '../../common/components/TableHeader';
import { getTransactionsForUser } from '../transaction.selectors';

const baseFormData = {
  dateFrom: '',
  dateTo: '',
  keyword: '',
  count: 10,
};

const constraints = {};

class TransactionsSearchFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      formData: Object.assign({}, baseFormData),
      dialogOpen: false,
      deletableEntity: null,
      transactions: [],
      tableHead: [
        { name: 'createdAt', uiName: Localize('transaction.createdAt') },
        { name: 'timestamp', uiName: Localize('transaction.date') },
        { name: 'product.productCategory.name', uiName: Localize('package') },
        { name: 'product.type', uiName: Localize('type') },
      ],
    };
  }

  componentWillMount() {
    const { getTransactionsForUser, userId } = this.props;

    userId && getTransactionsForUser(userId);
    
    this.updateSortData(this.props.transactions);
  }

  componentWillReceiveProps(nextProps) {
    const { getTransactionsForUser, userId } = this.props;

    if (nextProps.userId && nextProps.userId !== userId) {
      // userId was set, issue a read transactions action for that user
      getTransactionsForUser(nextProps.userId);
    }
    this.updateSortData(nextProps.transactions);
  }

  updateSortData = content => {
    this.setState(
      Object.assign({}, this.state, {
        transactions: content ? content : [],
      })
    );
  };

  sortTable = headItem => {
    const sorted = sortTableAndHead(headItem, this.state.tableHead, this.state.transactions);

    this.setState(
      Object.assign({}, this.state, {
        transactions: sorted.data,
        tableHead: sorted.head,
      })
    );
  };

  // componentWillMount = () => {
  //   const { getAllTransactions, currentUser } = this.props;

  //   getAllTransactions(currentUser._id);
  // };

  getConstraints = () => constraints;

  onDelete = id => {
    this.setState({
      dialogOpen: true,
      deletableEntity: id,
    });
  };

  cancelDelete = event => {
    this.setState({
      dialogOpen: false,
      deletableEntity: null,
    });
  };

  confirmDelete = event => {
    const { deleteTransaction } = this.props;
    const { deletableEntity } = this.state;

    deleteTransaction(deletableEntity).then(() => {
      this.setState({
        dialogOpen: false,
        deletableEntity: null,
      });
    });
  };

  onClose = event => {
    event.preventDefault();

    const { cancelPath, history } = this.props;
    history.replace(cancelPath);
  };

  renderTransactionRow = transaction => {
    const { _id, createdAt, timestamp, product } = transaction;

    const { productCategory } = product;
    const displayType = formatProductDisplayName(product);

    return (
      <tr key={_id}>
        <td>{formatDate(createdAt)}</td>
        <td>{formatDate(timestamp)}</td>
        <td>{productCategory.name}</td>
        <td>{displayType}</td>
        <td>
          <a onClick={partial(this.onDelete, _id)}>{Localize('action.delete')}</a>
        </td>
      </tr>
    );
  };

  renderTableHeader = () => {
    return (
      <TableHeader items={this.state.tableHead} onSort={this.sortTable} sortable={this.state.transactions.length > 1} />
    );
  };

  render() {
    const { title } = this.props;
    const transactions = this.state.transactions;

    return (
      <ContentBlock title={title}>
        <TransactionsSearchForm
          enabled={!this.state.isSubmitting}
          onSubmit={this.onSubmit}
          onInputChange={this.onInputChange}
          dateFrom={this.state.formData.dateFrom}
          dateTo={this.state.formData.dateTo}
          salesId={this.state.formData.salesId}
          count={this.state.formData.count}
        />
        {transactions && transactions.length > 0 ? (
          <Table
            items={transactions.slice(0, this.state.formData.count)}
            renderHeader={this.renderTableHeader}
            renderItem={this.renderTransactionRow}
          />
        ) : (
          <p>Ei vielä myyntejä.</p>
        )}
        <Dialog
          open={this.state.dialogOpen}
          title={Localize(`transaction.delete.confirm`)}
          cancelLabel={Localize('action.cancel')}
          confirmLabel={Localize(`transaction.delete`)}
          onCancel={this.cancelDelete}
          onConfirm={this.confirmDelete}
        >
          <p>{Localize('form.no.cancel')}</p>
        </Dialog>
      </ContentBlock>
    );
  }
}

const mapStateToProps = (state, { match, cancelPath }) => {
  const { userId } = match.params;
  let transactions = getTransactionsForUser(state, userId);
  // transactions = transactions.filter(t => t.userId == userId);
  const user = getUser(userId);
  return {
    userId,
    user,
    transactions,  
    cancelPath
  };
};

const ConnectedTransactionsSearchFormContainer = connect(mapStateToProps, transactionActions)(
  TransactionsSearchFormContainer
);

export default withRouter(ConnectedTransactionsSearchFormContainer);



// WEBPACK FOOTER //
// ./src/modules/transaction/components/TransactionsSearchFormContainer.js